import classNames from "classnames";
import Tab from "./Tab";

export type TabProps = {
  name: string;
  icon?: React.ReactNode;
  title?: string;
};

type Props = {
  active: string;
  tabs: TabProps[];
  className?: string;

  onActiveChange: (name: string) => void;
};

const Tabs = ({
  active,
  tabs,
  className,
  onActiveChange,
}: Props): JSX.Element => (
  <div
    className={classNames(
      "border-b border-gray-200 dark:border-gray-700",
      className
    )}
  >
    <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400 m-0 p-0">
      {tabs.map(({ name, icon, title }) => (
        <Tab
          key={name}
          active={active === name}
          icon={icon}
          onClick={() => onActiveChange(name)}
        >
          {title}
        </Tab>
      ))}
    </ul>
  </div>
);

export default Tabs;
